import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { Flex } from '@fabric-app/ui/components/Flex';
import { ResourceColorLabelColumn } from './ResourceColorLabelColumn.js';

const ResourceColorLabelColumns = ({ colorLabels, layoutId, ...rest }) => {
  return /* @__PURE__ */ jsxs(HorizontalContainer, {
    gap: "sections",
    children: [
      /* @__PURE__ */ jsx(ResourceColorLabelColumn, {
        colorLabel: null,
        ...rest,
        layoutId: `${layoutId}-uncategorized`
      }),
      (colorLabels || []).map((colorLabel) => /* @__PURE__ */ jsx(ResourceColorLabelColumn, {
        colorLabel,
        ...rest,
        layoutId: `${layoutId}-${colorLabel.id}`
      }, colorLabel.id))
    ]
  });
};
const HorizontalContainer = styled(Flex).withConfig({
  displayName: "ResourceColorLabelColumns__HorizontalContainer",
  componentId: "sc-8b888782-0"
})([
  `height:100%;padding:32px;overflow-x:auto;`
]);

export { ResourceColorLabelColumns };
//# sourceMappingURL=ResourceColorLabelColumns.js.map
